module.exports = __webpack_public_path__ + "img/online_course_hero.af890bc5.png";